import React from 'react';

import { ColumnDef } from '@tanstack/react-table';
import { Offer } from 'common/contracts';

import DataTable from 'components/DataTableComponent/DataTable';
import EmptyState from 'components/EmptyState/EmptyState';

interface IOfferTableContentProps {
  offers: Offer[];
  displayData: Offer[];
  columns: ColumnDef<Offer>[];
  totalCount: number;
  totalPages: number;
  rowsPerPage: number;
  currentPage: number;
  onPageChange: (page: number) => void;
  isLoading: boolean;
  onCreateClick: () => void;
  canCreate: boolean;
  emptyStateTitle: string;
  emptyStateDescription: string | React.ReactNode;
  createButtonPrefix: string;
  bodyDataTestId: string;
  emptyStateIcon?: React.ReactNode;
}

export const OfferTableContent = ({
  offers,
  displayData,
  columns,
  totalCount,
  totalPages,
  rowsPerPage,
  currentPage,
  onPageChange,
  isLoading,
  onCreateClick,
  canCreate,
  emptyStateTitle,
  emptyStateDescription,
  createButtonPrefix,
  bodyDataTestId,
  emptyStateIcon
}: IOfferTableContentProps): React.ReactElement => {
  const buttonText = `${offers.length > 0 ? 'Add' : 'Create'} New ${createButtonPrefix}`;

  if (offers.length === 0 && !isLoading) {
    return (
      <EmptyState
        title={emptyStateTitle}
        description={emptyStateDescription}
        buttonText={buttonText}
        className="mx-auto mt-36"
        onClick={onCreateClick}
        disableButton={!canCreate}
        icon={emptyStateIcon}
      />
    );
  }

  return (
    <div className="border border-base-sidebarBorder rounded-lg mx-7 mb-9">
      <DataTable
        data={displayData}
        columns={columns}
        rowIdIdentifier="offerId"
        bodyDataTestId={bodyDataTestId}
        rowCount={totalCount}
        rowsPerPage={rowsPerPage}
        showPagination={totalPages > 1}
        manualPagination
        pageIndex={currentPage}
        pageCount={totalPages}
        onPageChange={onPageChange}
        isLoading={isLoading}
      />
    </div>
  );
};
